module.exports = "https://d1tntvpcrzvon2.cloudfront.net/vpassets/_next/static/images/review-stars-016133e1314b7e6bc4821d62fafe3592.svg";